import queryString from 'qs';
import tuneInRequest from '../tuneInRequest';
export default function alexaService(config, apiContext, applyReauth) {
    const apiEndpoint = `${config.domains.api}/alexaskill`;
    const alexaEndpoints = {
        status: 'status',
        link: 'link',
        urls: 'urls',
    };
    function getStatus() {
        return tuneInRequest({
            method: 'get',
            url: `${apiEndpoint}/${alexaEndpoints.status}`,
            isAjax: false,
            disableRetry: true,
        }, apiContext);
    }
    function getUrls() {
        return tuneInRequest({
            method: 'get',
            url: `${apiEndpoint}/${alexaEndpoints.urls}`,
            isAjax: false,
            disableRetry: true,
        }, apiContext);
    }
    function linkAlexa(data) {
        return tuneInRequest({
            method: 'post',
            url: `${apiEndpoint}/${alexaEndpoints.link}`,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            isAjax: false,
            data: queryString.stringify(data),
            disableRetry: true,
        }, apiContext);
    }
    return {
        getStatus: applyReauth(getStatus),
        linkAlexa: applyReauth(linkAlexa),
        getUrls: getUrls,
    };
}
